// GET /orgs — list of orgs + datasources the signed-in user can access.

import { api } from "./base";

export interface Datasource {
  id: string;
  name: string;
}

export interface OrgSummary {
  org_id: string;
  name: string;
  description: string;
  fiscal_year_start_month?: number;
  datasources: Datasource[];
}

export async function fetchOrgs(bearer: string): Promise<OrgSummary[]> {
  const resp = await fetch(api("/orgs"), {
    headers: { Authorization: `Bearer ${bearer}` },
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`/orgs returned ${resp.status}: ${text}`);
  }
  return (await resp.json()) as OrgSummary[];
}
